export const ONBOARDING_TOUR_FINISHED = 'onboardingTourFinished'
export const GOALS_COLLAPSED = 'goalsCollapsed'
export const TASKS_LIST_FILTER = 'tasksListFilter'
export const ROUTINES_LIST_FILTER = 'routinesListFilter'
export const GOALS_LIST_FILTER = 'goalsListFilter'

import { midnight, areEqual, addDays } from '@/helpers/date'

export default {
  SET_APP_LOADING (state, appLoading) {
    state.appLoading = appLoading
  },
  SET_CURRENT_PERIOD (state, currentPeriod) {
    state.currentPeriod = currentPeriod
  },
  SET_ONBOARDING_TOUR_FINISHED (state, value) {
    state.onboardingTourFinished = value
    localStorage.setItem(ONBOARDING_TOUR_FINISHED, value)
  },
  SET_SHOW_SETUP (state, value) {
    state.showSetup = value
  },
  SET_GOALS_COLLAPSED (state, value) {
    state.goalsCollapsed = value
    localStorage.setItem(GOALS_COLLAPSED, value)
  },
  SET_SOUND_EFFECT (state, soundEffect) {
    state.soundEffect = soundEffect
  },
  SET_LAST_REGISTRATION_AT (state, { date }) {
    localStorage.setItem('improvee_last_visit', date)
  },
  SET_TASKS_LIST_FILTER (state, { filter }) {
    console.log('SET_TASKS_LIST_FILTER', filter)
    localStorage.setItem(TASKS_LIST_FILTER, filter)
  },
  SET_ROUTINES_LIST_FILTER (state, { filter }) {
    console.log('SET_ROUTINES_LIST_FILTER', filter)
    localStorage.setItem(ROUTINES_LIST_FILTER, filter)
  },
  SET_GOALS_LIST_FILTER (state, { filter }) {
    console.log('SET_GOALS_LIST_FILTER', filter)
    localStorage.setItem(GOALS_LIST_FILTER, filter)
  },
  UPDATE_TODAY (state) {
    if (!state.today || !areEqual(state.today, midnight())) {
      state.today = midnight()
    }
  },
  ADD_DAY (state) {
    state.today = midnight(addDays(state.today, 1))
  },
}
